import i18n from '../../../i18n';

export default {
  aMonth: 'یک ماه',
  showRelative: 'نمایش نسبی',
  copy: 'کپی',
  reportName: 'عنوان گزارش',
  autumn: 'پاییز',
  averageAssignmentProgress: 'میانگین پیشرفت انجام‌دهنده',
  aYear: 'یک سال',
  completedAssignmentCount: 'تعداد وظایف تمام شده انجام‌دهنده',
  inProgressAssignmentCount: 'تعداد وظایف در حال انجام انجام‌دهنده',
  fromFirstOfYear: 'از ابتدای امسال',
  mainTitle: 'اصلی',
  notStartedAssignmentCount: 'تعداد وظایف شروع نشده انجام‌دهنده',
  parent: 'والد',
  percentage: 'درصد',
  periodOfReport: 'بازه زمانی گزارش',
  projects: 'پروژه',
  prepareReport: 'تهیه‌ی گزارش',
  reports: 'گزارشات',
  secondaryTitle: 'فرعی',
  select: 'انتخاب کنید',
  selectAProject: 'پروژه‌ای انتخاب کنید',
  selectATemplate: 'قالبی انتخاب کنید',
  showAllTasksInThisPeriodOfTime: 'نمایش وظایف در این بازه‌ی زمانی',
  sixMonth: 'شش ماه',
  spring: 'بهار',
  startDate: 'از تاریخ',
  summer: 'تابستان',
  templates: 'قالب‌ها',
  threeMonth: 'سه ماه',
  title: 'عنوان',
  toDate: 'تا تاریخ',
  toPrepareTheReportYouShouldSelectAtTemplate:
    'برای تهیه گزارش باید قالبی انتخاب کنید',
  value: 'مقدار',
  printReport: 'چاپ',
  verifyTitle: 'تأییدکننده',
  winter: 'زمستان',
  firstHalfYear: 'نیم سال اول',
  secondHalfYear: 'نیم سال دوم',
  time: 'زمان',
  project: 'پروژه',
  split: 'تقسیم بندی',
  getReportRangeDate(startDate: string, toDate: string) {
    return i18n.t('getReportRangeDate', {
      ns: 'taskManager',
      startDate,
      toDate,
    });
  },
  assignee: (override: string) =>
    override || i18n.t('assignee', { ns: 'taskManager' }),
};
